import convertDate from './convertDate'
import convertTime from './convertTime'
import convertTime2 from './convertTime2'
import convertDinheiro from './convertDinheiro'
import calculaDesconto from './calculaDesconto'
import montaMensagem from './montaMensagem'
import montaMensagemContato from './montaMensagemContato'
import retornarDesconto from './retornarDesconto'
import verificarMobile from './verificarMobile'
import retornarValorReais from './retornarValorReais'
import permitirVendaSemEstoque from './permitirVendaSemEstoque'
import retornarQtdCompradaItem from './retornarQtdCompradaItem'
import verificarProdutoEsgotado from './verificarProdutoEsgotado'
import retornarModoDelivery from './retornarModoDelivery'
import carregarCarrinhoLocal from './carregarCarrinhoLocal'
import validarCarrinhoLocal from './validarCarrinhoLocal'
import retornarQueryVendedor from './retornarQueryVendedor'

export default {
	convertDate,
	convertTime,
	convertTime2,
	convertDinheiro,
	calculaDesconto,
	montaMensagem,
	montaMensagemContato,
	retornarDesconto,
	verificarMobile,
	retornarValorReais,
	permitirVendaSemEstoque,
	verificarProdutoEsgotado,
	retornarQtdCompradaItem,
	retornarModoDelivery,
	carregarCarrinhoLocal,
	validarCarrinhoLocal,
	retornarQueryVendedor
}
